var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('p',_vm._g(_vm._b({class:['mb-0', _vm.icon === 'drag' ? 'mx-3' : ''],on:{"click":function($event){_vm.clicked = true}}},'p',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[(!_vm.clicked)?_c('span',[_vm._v(" "+_vm._s(_vm.unclickedTooltip)+" ")]):_vm._e(),(_vm.clicked)?_c('span',[_vm._v(" "+_vm._s(_vm.clickedTooltip)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }